export default {"src":"/_next/static/media/goal-cooking.d0f5da82.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};